(function($, window, document, s, undefined){


  var initAjaxAddToWishlist = function initAjaxAddToWishlist() {
    $('.add-to-wishlist-form')
      .on('ajax:success', function(e, data) {
        if (data.redirect_to) {
          window.location.replace(data.redirect_to);
          return;
        }
        var cssClass = data.success ? 'success' : 'error';
        var $submitBtn = $(e.target).find('[type="submit"]');

        s.showAndHideNotification(data.html, cssClass);

        s.statefulButtonChange($submitBtn, 'success');
      })
      .on('ajax:error', function ajaxAddToCartSuccess(e, html) {
        s.showAndHideNotification(
          'Το προϊόν δεν προστέθηκε επιτυχώς στα επιθυμητά σας προϊόντα.');

        s.statefulButtonChange($(e.target).find('[type="submit"]'), 'error');
      })
      .on('submit', function ajaxAddToCartSubmit(e){
        s.showLoadingSpinner($(e.target).find('[type="submit"]')[0], 'grey');
      });
  };

  s.callOnReady(initAjaxAddToWishlist);

})(jQuery, this, this.document, window.s);
